module.exports = "\r\n     <h2><b>Not Authorized To View The Page</b></h2>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/not-authorized/not-authorized.component.html
// module id = ./src/app/component/not-authorized/not-authorized.component.html
// module chunks = main